/**
 * Página de éxito del checkout AR (/exclusive-ar y /exclusive-ar?tier=vip).
 * Mercado Pago redirige aquí (back_url) tras el pago; mostramos gracias y botón para ingresar al grupo.
 * successPath enviado en create-subscription: "/exclusive-ar/success"
 */

import GraciasAr from "@/components/GraciasAr";

export default function ExclusivoArSuccess() {
  return <GraciasAr />;
}
